import { Injectable } from '@angular/core';
import { EventsService } from '../event/event.service';
import { UserSessionService } from '../user-session/user-session.service';
import { Navigator } from "src/app/components/menu/navigator";
import { GameHubControllerService } from '../gameHub/game-hub-controller';
import { AuthenticationService } from '../authentication/authentication.service';
import { AppstorageTsService } from '../appstorage/appstorage.ts.service';

@Injectable({
	providedIn: 'root'
})
export class LogoutService {

	public responsibleGamingNumber: string;
	public responsibleGamingMessage: string;
	public isShowingPopover: boolean = false;
	public calledWithinInterval = false;

	constructor(
		private appStorage: AppstorageTsService,
		private eventsService: EventsService,
		private navigator: Navigator,
		private userSession: UserSessionService,
		private authenticationService: AuthenticationService,
		private gameHubController: GameHubControllerService,
	) {
		this.eventsService.subscribe('GlobalErrorHandlerService:action:logout', (params) => {
			this.userSession.isAuthenticated().then(isAuthenticated => {
				if (isAuthenticated) {
					this.onLogout(params);
				}
			})
		});

		this.eventsService.subscribe('logout:refresh', () => {
			this.onLogout();
		})
	}

	onLogout(params: any = null) {
		this.callLogout(params);
		this.eventsService.unsubscribe('GlobalErrorHandlerService:action:logout');
		this.eventsService.publish('event:authentication:logout');
		this.eventsService.publish("event:lobby:show");
		this.eventsService.publish("event:notification:resume");
		this.appStorage.setPlayerAsSocial(false);
	}

	callLogout(params: any = null) {
		return new Promise((resolve, reject) => {
			this.authenticationService.callLogout(params).subscribe(
				(response: any) => {
					resolve(response);
				},
				(error: any) => {
					reject(error);
				},
				() => {
					resolve(null);
				}
			);
		}).finally(() => {
			this.callClientCleanup();
		});
	}

	callClientCleanup() {
		if (this.navigator.activeModals.length > 0) {
			this.navigator.activeModals.forEach(modal => {
				modal.dismiss();
			});
		}
		// Clear User Session
		this.userSession.clear();
		this.gameHubController.closeOdrInstanceWindow();
		this.navigator.dismissAll();
		this.navigator.onReloadApp();
	}

}
